(function(){
    angular
        .module('appback')
        .directive('ngAlergias064', alergias064);

        alergias064.$inject = ['Upload','ResultadosService','$timeout'];
        function alergias064(Upload,ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=alergias064.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  sub: '=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
			               scope.subanaliticas = data.subanaliticas;
			            });
				        console.log("resultadoAelergia",scope.item.resultado);

			            if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { subanalitica : {} }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { subanalitica : {} }};
				            }
				        }

				        if(angular.isArray(scope.item.resultado.extra.resultado.subanalitica)){
				        	console.log("ES UN ARRAY");
				        	scope.item.resultado.extra.resultado.subanalitica = {};
				        }

				        scope.borrarFichero = function(index){
				        	scope.item.resultado.extra.resultado.ficheros.splice(index,1);
				        }

				        scope.uploadFiles = function (files) {
				          if (files && files.length) {
				            for (var i = 0; i < files.length; i++) {
				              Upload.upload({
				                    url: '/backend/resultadopeticion/subiralergia',
				                    data: { file: files[i] }
				                }).then(function (resp) {
				                    //onsole.log(resp);
				                    if(angular.isUndefined(scope.item.resultado.extra.resultado.ficheros)){
				                    	scope.item.resultado.extra.resultado.ficheros = [];
				                    }
				                    scope.item.resultado.extra.resultado.ficheros.push(resp.data);

				                    if(angular.isDefined(resp.data.resultados)){
				                    	console.log("subanalitica",scope.item.resultado.extra.resultado.subanalitica);
				                    	for(var cont = 0;cont<resp.data.resultados.length;cont++){
				              				if(angular.isUndefined(scope.item.resultado.extra.resultado.subanalitica[resp.data.resultados[cont].code])){
				              					scope.item.resultado.extra.resultado.subanalitica[resp.data.resultados[cont].code] = {};
				              				}
				                    		scope.item.resultado.extra.resultado.subanalitica[resp.data.resultados[cont].code].resultado = resp.data.resultados[cont].value;
				                    	}
				                    	console.log("subanalitica",scope.item.resultado.extra.resultado.subanalitica);
				                    }
				                    //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
				                }, function (resp) {
				                    //console.log('Error status: ' + resp.status);
				                }, function (evt) {
				                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
				                    //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
				                });
				            }
				            
				          }
				        }

		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                    }

	                    scope.valorNormalidad = function(analitica){
				            var resultado = false;
				            if(analitica.valoresnormalidad.interpretacion){
				              for(var cont = 0;cont<analitica.valoresnormalidad.interpretacion.length && !resultado;cont++){
				              	if(angular.isDefined(scope.item.resultado.extra.resultado.subanalitica)){
					                if(typeof(scope.item.resultado.extra.resultado.subanalitica[analitica.codigo_alfa]) != 'undefined' && ((analitica.valoresnormalidad.interpretacion[cont].from=='' || parseFloat(scope.item.resultado.extra.resultado.subanalitica[analitica.codigo_alfa].resultado)>=parseFloat(analitica.valoresnormalidad.interpretacion[cont].from)) && (analitica.valoresnormalidad.interpretacion[cont].to=='' || parseFloat(scope.item.resultado.extra.resultado.subanalitica[analitica.codigo_alfa].resultado)<parseFloat(analitica.valoresnormalidad.interpretacion[cont].to)))){
					                  resultado = analitica.valoresnormalidad.interpretacion[cont];
					                }
					            }
				              }
				            }
				            return resultado;
				        }

			        });
		        }
          }
      }
})();